<template lang="pug">
.order_form_point
  .form-ctn
    PointSelect(:config="{ must: true }" labelText="广告类型" v-model="elType" :pList="adTypes")
      .my-sel-empty__data(slot="empty") 暂未开通，请联系管理员
    el-form(size="mini" :model="order")
      el-form-item.must(label="投放城市")
        MultCityAsync(@change="getAddressCodes" ref="cityChoose")

      el-form-item.must(label="投放日期")
        el-date-picker.input-date(
          type="date" v-model="order.startDate" value-format="yyyy-MM-dd" :clearable="false"
          placeholder="选择开始日期" style="margin-right: 6px;" prefix-icon="el-icon-arrow-down"
          @change="startDateChange" :picker-options="startPickerOptions"
        )
        span(style="font-size: 12px;") 至
        el-date-picker.input-date(
          type="date" v-model="order.endDate" value-format="yyyy-MM-dd" :clearable="false"
          placeholder="选择结束日期" prefix-icon="el-icon-arrow-down" @change="endDateChange"
          :picker-options="endPickerOptions"
        )
        i.iconfont.icon-biaodan-shijian.fr(style="margin-right: 10px;")

      el-form-item.must(label="单次曝光")
        el-select(v-model="order.contentTime" placeholder="选择单次曝光" popper-class="form_pop")
          el-option(
            v-for="(item, i) in contentTimes" :key="i"
            :value="item.dictItemName" :label="item.dictItemName+'秒'"
          )
      //- PointSelect(:config="{must: true, placeholder: '选择单次曝光'}" labelText="单次曝光" v-model="elTime" :pList="exposeList")

      el-form-item.must.time-limit(label="每日流量上限")
        el-input(
          v-model="order.daliFlowLimit" size="mini" placeholder="请输入"
          @keyup.native="e => handleChange(e, 'daliFlowLimit')"
        )
          i(slot="append") 千人次

      el-form-item.must.price(label="合同单价")
        el-input(v-model="order.unitPrice" size="mini" placeholder="请输入" @keyup.native="e => handleChange(e, 'unitPrice', 2)")
          i(slot="append") 元/千人次

      el-form-item.must.custom(label="合同编码")
        el-input(placeholder="请输入正确的合同编码" :maxlength="30" v-model="order.contractNo" @blur="contractHandle" @keyup.enter.native="contractHandle")
          i.iconfont.icon-biaodan-tianxie(slot="suffix")

      el-form-item.must(label="展现位置")
        el-select(v-model="order.displayRegion" placeholder="选择展现位置" popper-class="form_pop")
          el-option(v-for="reg in displayRegions" :key="reg.value" :label="reg.label" :value="reg.value")

    LabelCmp(ref="labelCmp" @change="labelDataChange")

    .search_btn(@click="handleSearch") 提交订单

</template>

<script>
import PointSelect from '@/views/PutOrder/components/OrderForm/Select'
import CustomUser from '@/views/PutOrder/components/OrderForm/CustomUser'
import LabelCmp from '@/views/PutOrder/components/OrderForm/LabelCmp.vue'
import searchPointMix from '@/utils/mixins/searchPointMix'

const dayMs = 24 * 3600000
const dateNow = new Date()

export default {
  name: 'OrderFormPoint',
  components: {
    PointSelect,
    CustomUser,
    LabelCmp
  },
  mixins: [searchPointMix],
  data() {
    let vm = this
    return {
      adTypes: [],
      elType: [],
      elTime: [],
      labelParam: {},
      commonLabelData: [],
      order: {
        advertType: '',
        startDate: new Date(+dateNow + 2 * dayMs).format().slice(0, 10),
        endDate: new Date(+dateNow + 8 * dayMs).format().slice(0, 10),
        daliFlowLimit: '',
        contractNo: '',
        displayRegion: 1
      },
      startPickerOptions: {
        disabledDate (t) {
          const dt = new Date(t)
          return dt - dateNow < -dayMs || dt - dateNow > 89 * dayMs
        }
      },
      endPickerOptions: {
        disabledDate (d) {
          const dt = new Date(d)
          const theStart = new Date(vm.order.startDate)
          return dt - theStart - 89 * dayMs > 0 || dt - theStart < -dayMs || dt - dateNow > 89 * dayMs
        }
      },
      contentTimes: []
    }
  },
  computed: {
    originTypes() {
      return this.$store.state.common.advertTypes
    },
    exposeList() {
      return this.contentTimes.map(e => {
        return {
          ...e,
          code: e.dictItemName,
          name: e.dictItemName+'秒'
        }
      })
    }
  },
  watch: {
    elType(v) {
      if (v && v[0]) {
        this.order.advertType = v[0]
      } else {
        this.order.advertType = undefined
      }
    },
    elTime(v) {
      if (v && v[0]) {
        this.order.contentTime = v[0]
      } else {
        this.order.contentTime = undefined
      }
    }
  },
  async created() {
    if (!this.originTypes || !this.originTypes.length) await this.$store.dispatch('getAdvertType')
    // 限量广告 => RTB(限量)(11)、定制商业(3)、普通公益(4)、定制公益(5)
    const auth = this.originTypes.filter(e => [11, 3, 4, 5].indexOf(e.value) > -1)
    this.adTypes = auth.map(e => {
      e.code = e.value
      e.name = e.label
      return e
    })

    // 单次曝光 选择数据字典
    this.contentTimes = await this.getContentTimes()
    this.initContentTime()
  },
  methods: {
    contractHandle() {
      this.order.contractNo = (this.order.contractNo || '').trim()
    },
    handleChange(e, k, floatNum) {
      let v = (e.target.value || '').trim()
      if (!floatNum) return (this.order[k] = v.replace(/[^\d]/g, ''))
      let arr = v.split('.')
      let f = (arr[0] || '0').replace(/[^\d]/g, '')
      if (arr.length > 1) {
        f += '.' + (arr[1] || '').slice(0, floatNum).replace(/[^\d]/g, '')
      }
      return (this.order[k] = f)
    },
    labelDataChange(data, type) {
      this.order.labelDataChangeType = type == 'profile' ? '' : type
      if (type == 'indus') {
        // 我的行业
        let codes = []
        data.forEach((el) => {
          codes = codes.concat(el.chooses.map((ele) => ele.code))
        })
        this.order.industryCodes = codes
        this.commonLabelData = []
        this.order.originPerson = []
        this.order.personsLabels = []
      } else {
        // 自定义标签
        if (type == 'common') {
          this.commonLabelData = data
        } else if (type == 'profile') {
          // 用户画像
          this.profileChange(data)
        }
        this.order.industryCodes = []
      }
    },
    reset() {
      this.initContentTime()
      if (this.$refs.cityChoose) this.$refs.cityChoose.initHangZhou()
      this.order.startDate = new Date(+dateNow + 2 * dayMs).format().slice(0, 10)
      this.order.endDate = new Date(+dateNow + 8 * dayMs).format().slice(0, 10)
      this.initSearchTimeRange()
      this.order.contractNo = ''
      this.$refs.labelCmp.init()
    },
    initContentTime() {
      let dft = this.contentTimes.filter((el) => el.default)[0] // 默认
      if (dft) {
        this.$set(this.order, 'contentTime', dft.dictItemName)
        this.elTime = [dft.dictItemName]
      }
    },
    startDateChange(data) {
      if (this.order.endDate && new Date(data).getTime() > new Date(this.order.endDate).getTime()) {
        this.messageTip('结束时间须不能小于开始时间')
        this.order.endDate = ''
      }
    },
    endDateChange(data) {
      if (this.order.startDate && new Date(data).getTime() < new Date(this.order.startDate).getTime()) {
        this.messageTip('结束时间须不能小于开始时间')
        this.order.endDate = ''
      }
    },
    getAddressCodes(data, initData) {
      // 改成只传选中所有的第一层
      this.getAddressCodesFirst(data, initData)
      return

      // 过滤到底层   也可以直接 getCheckedNodes 第一个参数传入(true)来获取，不用下面的
      // let final = []
      // let repeat = (arr) => {
      //   arr.forEach((el) => {
      //     if (el.children && el.children.length > 0) repeat(el.children)
      //     else final.push(el)
      //   })
      // }
      // repeat(data)
      // this.order.addressCodes = [...new Set(final)].map((el) => el.ids)
    },
    getAddressCodesFirst(res, initData) {
      if (initData) {
        this.order.addressCodes = initData
        return
      }
      let addressCodesParam = this.rmCheckItemChilds(res)
      this.order.addressCodes = addressCodesParam.map((el) => el.split('^^').join('.')).map((el) => (el.indexOf('.') < 0 ? el + '.' : el))
    },
    rmCheckItemChilds(res) {
      // 去除已选数据的子集数据：比如杭州市是选中状态，滨江区等区域选中的数据就不传参了
      let data = []
      let final = res.map((el) => el.ids).sort()
      final.forEach((item) => {
        data.forEach((el) => {
          if ((item + '').indexOf(el) > -1) item = null
        })
        if (item) data.push(item + '')
      })
      return data
    },
    handleSearch() {
      if (!this.testInput()) return
      let labelParamList = this.commonLabelData
      let chargeTarget = ['L3'] // 限时投放固定传
      // searchPointMix 里的方法  处理传参字段 condition, nbhdLabels(社区收入 社区类型), orderLabels(收费方式 预算 目标),
      let condition = this.handleLabelsParam(this.order, labelParamList, chargeTarget)
      console.log('advert RTB:', condition)

      let opt = JSON.parse(JSON.stringify(condition))
      this.$emit('submit', opt) // 深拷贝下 this.order 以免一些数据操作并未搜索 影响其他内容展示
      this.$store.commit('setStoreData', {
        key: 'conditionSearchCitys',
        value: this.$refs.cityChoose.$refs.tree.getCheckedNodes(false, true)
      })
      this.$store.commit('order/setForm', condition)
    },
    testInput() {
      let order = this.order

      if (!order.advertType) {
        return this.messageTip('请选择广告类型', 2)
      }

      let adsCodes = order.addressCodes
      if (!adsCodes || adsCodes.length == 0) {
        if (this.$refs.cityChoose && this.$refs.cityChoose.isWhole) {
          // order.addressCodes = [1] // 暂时全国传空数组
        } else {
          return this.messageTip('请选择投放城市', 2)
        }
      }

      if (!order.startDate) return this.messageTip('请选择投放开始日期', 2)
      if (!order.endDate) return this.messageTip('请选择投放结束日期', 2)

      if (new Date(order.startDate).getTime() > new Date(order.endDate).getTime()) {
        return this.messageTip('结束日期须大于等于开始日期', 2)
      }
      // 开始时间最多和结束时间相差一月
      if (new Date(order.endDate).getTime() - new Date(order.startDate).getTime() > 30 * 24 * 60 * 60 * 1000) {
        return this.messageTip('时间范围须小于等于31天', 2)
      }

      let adLong = (order.contentTime || '').trim()
      if (!adLong) return this.messageTip('请选择单次曝光', 2)
      let limitNum = (order.daliFlowLimit || '').trim()
      if (limitNum === '') return this.messageTip('请输入每日流量上限', 2)
      if (limitNum - 0 <= 0) return this.messageTip('每日流量上限须大于0', 2)

      let price = (order.unitPrice || '').trim()
      if (price === '') return this.messageTip('请输入合同单价', 2)
      if (price - 0 <= 0) return this.messageTip('合同单价须大于0', 2)

      if (!order.contractNo) return this.messageTip('请输入合同编码', 2)

      return true
    }
  }
}
</script>

<style lang="sass" scoped>
.more
  text-align: center
  line-height: 40px
  color: #FF3973
  background: rgba(255,57,115,0.05)
  cursor: pointer
  margin-top: 20px

.order_form_point
  padding: 20px
  height: 100%
  overflow: auto

  .form-ctn
    height: 100%
    overflow-x: hidden
    overflow-y: auto

  .custom
    .el-input
      font-size: 12px
      padding-right: 25px

  ::v-deep .el-form
    .el-form-item
      margin-bottom: 20px
      box-shadow: 0 0 0 1px #e9e9e9 inset
      border-radius: 4px
      padding: 5px 0 5px 19px

      &.time-limit, &.price
        .el-input
          width: 190px
          input
            width: 110px
          .el-input-group__append
            background: none
            border: none
            width: 80px
            padding-left: 5px
            padding-right: 0
      &.time-limit label
        width: 100px

      .el-form-item__label
        color: #282729
        font-weight: 600
        border-right: 1px solid #e9e9e9
        padding: 0
        margin-top: 5px
        line-height: 20px
        width: 68px
        text-align: left

    .el-form-item__content
      .el-select
        .el-select__tags
          padding-left: 10px
    .icon-biaodan-shijian
      color: #c0c4cc

    > .el-input
      font-size: 12px

    .el-select, .el-input
      width: 220px
      &.input-date
        width: 86px
        padding-left: 0
        margin-right: 5px
        > input
          padding-left: 10px
      input
        border: none
        padding-right: 0
        padding-left: 10px
        &:focus
          border-bottom: none !important
      .el-input__prefix
        display: none

    .el-select .el-tag
      margin: 2px 2px 2px 0

  .el-input--mini
    font-size: 14px

.time
  position: relative
  span.tip
    color: #999
    font-size: 12px
    position: absolute
    left: 68px
    bottom: -30px

.btm
  border-top: 1px solid #E9E9E9
  padding: 0  20px
  position: absolute
  bottom: 0
  width: 100%
  margin: 0 -20px
  text-align: center
.search_btn
  display: inline-block
  width: 100%
  line-height: 40px
  cursor: pointer
  background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%)
  border-radius: 4px
  color: #fff
  font-weight: 400
  margin: 15px 20px 15px 0
  text-align: center
</style>
